import { RESET_REG_FLOW, SET_BASIC_INFO, SET_ADDRESS, SET_PHONE_NUMBER, SET_IMAGE_INFO, SET_RETURN_TO } from './action-types/registration-actions'

export const resetRegFlow = () => {
  return {
    type: RESET_REG_FLOW
  }
}

export const setBasicInfo = (basicInfo) => {
  return {
    type: SET_BASIC_INFO,
    basicInfo
  }
}

export const setAddress = (location) => {
  return {
    type: SET_ADDRESS,
    location
  }
}

export const setPhoneNumber = (tel_number) => {
  return {
    type: SET_PHONE_NUMBER,
    tel_number
  }
}

export const setImageInfo = (imageInfo) => {
  return {
    type: SET_IMAGE_INFO,
    photo_ids: imageInfo   
  }
}

export const setReturnTo = (return_to_path) => {
  return {
    type: SET_RETURN_TO,
    return_to_path: return_to_path
  }
}
